import { useContext } from 'react';
import { TabsContext } from './createContextTab';

interface ITabsContext {
    /**
     * The label of the currently active Tab.
     */
    activeTab: string;
  
    /**
     * Whether the Tabs component should stretch the full width of its container
     */
    fullWidth: boolean;
  
    /**
     * Callback to handle click event.
     */
    onClick: (label: string) => void;
  }
/**
 * Hook which exposes parts of the `ITabsContext` for state
 * consumption.
 */
export const useTabs = (): ITabsContext => {
    const context = useContext(TabsContext);
    if (!context) {
      throw new Error('This component must be used within a <Tabs> component.');
    }
    return context;
  };